import { Preferences } from "../../profile/objects/preferences";
import { CENTRAL_PAYEMENT_MODULE, DEFAULT_COLUMN } from "../constant/centralPaymentConstant";
import { Column } from "../objects/column";
import { setListPreference, ListPreferenceResult } from "../../utils/list/utils/setListPreference";

export const setCentralPaymentPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: CENTRAL_PAYEMENT_MODULE,
        default_columns: DEFAULT_COLUMN,
        default_order_by: '-created_date',
    });
